import localizationStrings from "../../statics/localization";

const copy = {
  eng: {
    loadingEyebrow: "YOUR NEXT STORY",
    loadingTitle: "A little anticipation.",
    loadingNote: "We’re getting everything ready for you.",
    loadingLabel: "Loading",
    offlineTitle: "Your connection took a break.",
    offlineNote:
      "You’re offline. Check your connection, then try again when you’re back online.",
    timeoutTitle: "This is taking a little too long.",
    timeoutNote: "We haven’t heard back yet. Try again to continue.",
    errorEyebrow: "A BRIEF INTERMISSION",
    errorTitle: "Let’s try that again.",
    errorNote:
      "We couldn’t load this right now. Try again, or head back to explore.",
    crashTitle: "The story doesn’t end here.",
    crashNote:
      "Something unexpected interrupted this page. Try again to pick up where you left off.",
    notFoundEyebrow: "OFF THE SCRIPT",
    notFoundTitle: "This scene is missing.",
    notFoundNote:
      "This page may have moved, or the link is no longer available. There’s still plenty to discover.",
    retry: "Try again",
    home: "Back to home",
    login: "Back to sign in",
    signature: "EVERY STORY. A NEW WORLD."
  },
  tr: {
    loadingEyebrow: "SIRADAKİ HİKÂYEN",
    loadingTitle: "Güzel hikâyeler biraz bekletir.",
    loadingNote: "Senin için her şeyi hazırlıyoruz.",
    loadingLabel: "Yükleniyor",
    offlineTitle: "Bağlantına kısa bir ara.",
    offlineNote:
      "İnternet bağlantın yok. Bağlantını kontrol et ve yeniden bağlandığında tekrar dene.",
    timeoutTitle: "Bu kez biraz uzun sürdü.",
    timeoutNote:
      "Henüz yanıt alamadık. Devam etmek için tekrar deneyebilirsin.",
    errorEyebrow: "KISA BİR ARA",
    errorTitle: "Bir kez daha deneyelim.",
    errorNote:
      "Şu anda bu alanı yükleyemedik. Tekrar deneyebilir veya keşfetmeye geri dönebilirsin.",
    crashTitle: "Hikâye burada bitmiyor.",
    crashNote:
      "Beklenmeyen bir sorun bu sayfayı kesintiye uğrattı. Kaldığın yerden devam etmek için tekrar dene.",
    notFoundEyebrow: "SENARYONUN DIŞINDA",
    notFoundTitle: "Bu sahneyi bulamadık.",
    notFoundNote:
      "Sayfa taşınmış veya bağlantı artık geçerli olmayabilir. Keşfedilecek daha çok hikâye var.",
    retry: "Tekrar dene",
    home: "Ana sayfaya dön",
    login: "Girişe dön",
    signature: "HER HİKÂYE. YENİ BİR DÜNYA."
  },
  arb: {
    loadingEyebrow: "قصتك التالية",
    loadingTitle: "لحظة من الترقب.",
    loadingNote: "نجهّز كل شيء من أجلك.",
    loadingLabel: "جارٍ التحميل",
    offlineTitle: "انقطع اتصالك مؤقتاً.",
    offlineNote: "أنت غير متصل بالإنترنت. تحقق من الاتصال ثم حاول مرة أخرى.",
    timeoutTitle: "استغرق الأمر وقتاً أطول من المتوقع.",
    timeoutNote: "لم نتلق رداً بعد. حاول مرة أخرى للمتابعة.",
    errorEyebrow: "استراحة قصيرة",
    errorTitle: "لنحاول مرة أخرى.",
    errorNote: "تعذر تحميل هذه الصفحة الآن. حاول مرة أخرى أو عد للاستكشاف.",
    crashTitle: "القصة لا تنتهي هنا.",
    crashNote: "توقفت الصفحة بسبب مشكلة غير متوقعة. حاول مرة أخرى للمتابعة.",
    notFoundEyebrow: "خارج السيناريو",
    notFoundTitle: "هذا المشهد مفقود.",
    notFoundNote:
      "ربما نُقلت الصفحة أو لم يعد الرابط متاحاً. لا يزال هناك الكثير لاكتشافه.",
    retry: "إعادة المحاولة",
    home: "العودة للرئيسية",
    login: "العودة لتسجيل الدخول",
    signature: "كل قصة. عالم جديد."
  }
};

export const getStatusCopy = () =>
  copy[localizationStrings.getLanguage()] || copy.eng;
export const getRecoveryPath = () =>
  localStorage.getItem("hasLoggedIn") === "true" ? "/dashboard" : "/login";
